export default __webpack_public_path__ + "static/media/question.1f85eb9e.svg";